import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Email, Phone } from '@mui/icons-material';

// images
import LogoImg from '../../assets/images/BeautyBookLogo1.svg';

const PublicSupportInfo = () => {
  return (
    <Box
      className="card-animation fade-in"
      sx={{
        mx: 'auto',
        textAlign: 'center',
        width: { xs: '100%', sm: '80%', lg: '65%' },
      }}>
      <Box mt={2} mb={3}>
        <img style={{ width: '60%' }} src={LogoImg} alt="logo-img" />
      </Box>
      <Typography variant="h3" gutterBottom className="font-moon-time">
        Beautiful Software for your cosmetic clinic
      </Typography>
      <Stack sx={{ pb: 2, mt: 2 }} spacing={2} alignItems="center">
        <Typography variant="body1">
          Need any help? Reach out to our support team via phone or email
        </Typography>

        <Stack direction={{ sm: 'column', lg: 'row' }} spacing={1} alignItems="center">
          <Box display="flex" alignItems="center" gap={0.5}>
            <Phone color="secondary" fontSize="small" />
            <Typography
              sx={{
                '&:hover': {
                  color: '#fea889',
                },
              }}>
              <a href="tel:0735555888" style={{ textDecoration: 'none', color: 'inherit' }}>
                07 3555 5888
              </a>
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Email color="secondary" fontSize="small" />
            <Typography
              sx={{
                '&:hover': {
                  color: '#fea889',
                },
              }}>
              <a
                href="mailto:support@beautybook.software"
                style={{ textDecoration: 'none', color: 'inherit' }}>
                support@beautybook.software
              </a>
            </Typography>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PublicSupportInfo;
